import { isEmpty } from "lodash";
import parse, { domToReact } from "html-react-parser";

const Wysiwyg = ({ content, classes }) => {
  if (isEmpty(content)) return null;

  return (
    <div className={`wysiwyg ${classes}`}>
      {parse(content, {
        replace: (domNode) => {
          if (domNode.name === "ol") {
            const startAttr = domNode.attribs?.start;
            const start = parseInt(startAttr || "1", 10);
            const style = {
              "--ol-start": Math.max(0, start - 1),
            }

            return (
              <ol style={style} {...domNode.attribs}>
                {domToReact(domNode.children)}
              </ol>
            );
          }
        },
      })}
    </div>
  );
};

export default Wysiwyg;
